import { styled } from '@mui/material/styles'
import {
  Button,
  Card,
  Paper,
  Typography,
  Container,
  Box,
  TableContainer,
  Table,
  IconButton,
} from '@mui/material'

// Styled button that matches your header style
export const PrimaryButton = styled(Button)(({ theme }) => ({
  backgroundColor: theme.palette.primary.main,
  color: theme.palette.primary.contrastText,
  '&:hover': {
    backgroundColor: theme.palette.primary.dark,
  },
}))

// Secondary button (outlined style)
export const SecondaryButton = styled(Button)(({ theme }) => ({
  color: theme.palette.primary.main,
  borderColor: theme.palette.primary.main,
  '&:hover': {
    backgroundColor: 'rgba(52, 152, 219, 0.1)',
  },
}))

// Card component with consistent styling
export const StyledCard = styled(Card)(({ theme }) => ({
  borderRadius: 4,
  boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
  padding: theme.spacing(2),
  marginBottom: theme.spacing(2),
  height: '100%',
  display: 'flex',
  flexDirection: 'column',
}))

// Container for page content
export const PageContainer = styled(Container)(({ theme }) => ({
  maxWidth: '1200px',
  margin: '0 auto',
  padding: theme.spacing(2),
}))

// Section header
export const SectionHeader = styled(Typography)(({ theme }) => ({
  color:
    theme.palette.mode === 'dark'
      ? theme.palette.primary.main
      : theme.palette.secondary.main,
  borderBottom: `2px solid ${theme.palette.primary.main}`,
  paddingBottom: theme.spacing(1),
  marginBottom: theme.spacing(2),
  fontWeight: 500,
  fontSize: '1.25rem',
  variant: 'h2',
}))

// Form container
export const FormContainer = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(3),
  borderRadius: 4,
  boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
}))

// Styled table container
export const StyledTableContainer = styled(TableContainer)(({ theme }) => ({
  marginTop: theme.spacing(2),
  marginBottom: theme.spacing(2),
  borderRadius: 4,
  boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
}))

// Styled table
export const StyledTable = styled(Table)(({ theme }) => ({
  '& .MuiTableCell-root': {
    padding: theme.spacing(1.5),
  },
}))

// Card content container
export const CardContent = styled(Box)(({ theme }) => ({
  flex: 1,
}))

// Card actions container
export const CardActions = styled(Box)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'flex-end',
  padding: theme.spacing(2),
  paddingTop: 0,
}))

export const HeaderContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  width: '100%',
  maxWidth: '100vw',
  margin: 0,
  padding: theme.spacing(1),
}))

export const HeaderIconButton = styled(IconButton)(({ theme }) => ({
  color: 'inherit',
  marginLeft: theme.spacing(1),
  '&:hover': {
    backgroundColor: 'rgba(255, 255, 255, 0.08)',
  },
}))
